import React, { useState, useEffect } from "react";
import axios from "axios";
import useKeyboardShortcutBlocker from "./KeyboardShortcutBlocker";
import { message, Form, Input, Button, Alert } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from "jquery";
export const Headeronboarding = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [valueUserDetail, setValuegetuser] = useState([]);
  const [showssheader, setshowssheader] = useState(false);
  const [showsisClickedopen, setshowsisClickedopen] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem("users");
    navigate("/login");
  };
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const isMobileScreen = window.innerWidth <= 767.98;
  const [isDivVisible, setDivVisibility] = useState(!isMobileScreen);
  //useKeyboardShortcutBlocker();
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    const userStr = JSON.parse(localStorage.getItem("users"));
    if (userStr === null) {
      navigate("/login");
    }
    const handleResize = () => {
      const isMobile = window.innerWidth <= 767.98;
      if (isMobile !== isDivVisible) {
        setDivVisibility(!isMobile);
      }
    };
    if (userStr === null) {
      setshowssheader(false);
      document.title = "Home Page";
    } else {
      setshowssheader(true);
      let formdata = {
        user_id: userStr[0].id,
      };

      axios
        .post("https://jlmining.app/admin/getuserdetails", formdata, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          var alldata = res.data.row[0];
          console.log("sssss");
          console.log(alldata.status);
          if (alldata.status === "Active") {
            //navigate("/home");
          }
          setValuegetuser(alldata);
        })
        .catch((err) => { });
    }

    $(window).resize(handleResize);
    alterClass();
    return () => {
      $(window).off("resize", handleResize);
    };
  }, []);
  const handleResize = () => {
    alterClass();
  };
  const alterClass = () => {
    const ww = document.body.clientWidth;
    if (ww < 600) {
      $(".main-admin-block").addClass("close-box");
    } else if (ww >= 601) {
      $(".main-admin-block").removeClass("close-box");
    }
  };
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    contact: "",
    address: "",
  });

  const mobilepopup = () => {
    setshowsisClickedopen(!showsisClickedopen);
  };
  const fname = valueUserDetail.first_name;
  const mname = valueUserDetail.middle_name;
  const lname = valueUserDetail.last_name;
  const fLetter = fname ? fname.charAt(0) : "";
  const mLetter = mname ? mname.charAt(0) : "";
  const lLetter = lname ? lname.charAt(0) : "";
  const location = useLocation();
  const toggleDivVisibility = () => {
    setDivVisibility(!isDivVisible);
  };
  return (
    <>
      <header
        style={{ position: "relative", left: "0", right: "0" }}
        className="d-none d-sm-block"
      >
        <div className="container-lg">
          <div className="row gy-4 align-items-center justify-content-between">
            <div className="col-3 col-lg-2">
              <Link to="/home" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-lg-2 d-none d-md-block">
              <Link to="/home" className="logo-top">
                <img src={require("./assets/images/hss.png")} alt="logo" />
              </Link>
            </div>

            <div className="col-9 col-lg-6">
              {showssheader && (
                <div className="navbar-list align-items-center  d-flex gap-3 justify-content-end">
                  <Link className="logout" to="/logout">
                    Logout
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {/* mobile header */}

      <header
        style={{ position: "relative", left: "0", right: "0" }}
        className="d-block d-sm-none"
      >
        <div
          className="navbar-top"
          style={{ display: isDivVisible ? "block" : "none" }}
        >
          <div className="d-flex flex-column">
            <div className="nav-link-main d-flex flex-column">
              <div className="navbar-list  justify-content-end d-flex flex-column">
                <Link className="" to="/logout">
                  Logout
                </Link>
              </div>
            </div>
          </div>
        </div>
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
          <div class="container-fluid">
            <div class="d-flex justify-content-between  align-items-center">
              <div className="col-2 nav-mob">
                <button type="button" onClick={toggleDivVisibility}>
                  <i className="fal fa-bars"></i>
                </button>
              </div>
              <Link to="#" className="logo-top col-3 px-2 offset-1">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
              <Link to="#" className="logo-top col-3 px-2">
                <img src={require("./assets/images/hss.png")} alt="logo" />
              </Link>
              <div className="col-2 ms-auto">
                <div className="navbar-list float-end">
                  <p className="user-text-icon">
                    <Link to="/profile">
                      {fLetter} {mLetter} {lLetter}
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </nav>
        {/*
        <div className="container-lg">
          <div className="row gy-3 align-items-center justify-content-between">
            <div className="col-4">
              <Link to="#" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-4">
              <Link to="#" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>

            <div className="col-8"></div>
            <div className="col-12"></div>
          </div>
        </div> */}
      </header>
    </>
  );
};
